/**
 * Converts a list to a dictionary, using a key selector function as the index for each object in the list.
 * @param list The list to convert to a dictionary
 * @param idSelector Function that should return a unique key for T
 * @param valueSelector Optionaly function to allow transformation of values in the resultant dictionary
 * @typeparam T Input type
 * @typeparam U Output type, will be the same as T by default unless valueSelector is specified
 */
export function toDictionary<T, U>(
    list: T[],
    idSelector: (obj: T) => string | number,
    valueSelector: (obj: T) => U = a => a as unknown as U
): { [key: string]: U } | { [key: number]: U }
{
    return list.reduce((obj, item) => {
        obj[idSelector(item)] = valueSelector(item);
        return obj;
    }, {} as { [key: string]: U });
}